import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Img = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../images/location_img.png"
      alt="Trakking Gps collar inteligente Kolyy"
    />
  );
};

export default Img;
